// extracted by mini-css-extract-plugin
export default {"suggestions":"Suggestions-module__suggestions__wJUlUMk","suggestionButton":"Suggestions-module__suggestionButton__zCYxEKB"};